import React from "react"
import { has } from "lodash"

import InvitedList from "./InvitedList"

class PlatformInvite extends React.Component{
    constructor(){
        super()
        this.state = {
            friendName: "",
            friendEmail: "",
            nameError: "",
            emailError: "" ,
            invitedFriends: null,
            isLoading: true
        }
        this.gmailMatchRegex = /^[\w\d\.]+@gmail\.com$/
    }
    handleChange = (e) =>{
        const {name, value} = e.target
        this.setState({
            [name]:value,
            nameError: "",
            emailError: ""
        })
    }
    validate = () =>{
        if (this.state.friendName === ""){
            this.setState({nameError: "You have to enter your friend's name!"})
        }
        if (this.state.friendEmail === ""){
            this.setState({emailError: "You have to input something!"})
            return false
        }
        else if (!this.state.friendEmail.includes("@")){
            this.setState({emailError: "You have to input a valid email!"})
            return false
        }
        else if (!this.gmailMatchRegex.test(this.state.friendEmail)){
            this.setState({emailError: "We only accept gmail for now"})
            return false
        }
        else return true
    }
    handleSubmit = (e) =>{
        e.preventDefault();
        if (this.validate()){
            fetch(`/api/user/invitation/add`,{
                method: "post",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: this.state.friendName,
                    email: this.state.friendEmail.toLowerCase()
                })
            })
            .then(res => res.json())
            .then(data =>{
                if (has(data, "error")){ throw data }
                this.refreshFriendList()
            })
            .catch(data => this.setState({nameError: `Server: ${data.error}`}))
        }
    }
    componentDidMount(){
        this.refreshFriendList()
    }
    refreshFriendList = () =>{
        fetch(`/api/user/invitation/list`)
        .then(res => res.json())
        .then(data => {
            if (has(data,"error")){ throw data }
            this.setState({
                friendName: "",
                friendEmail: "",
                nameError: "",
                emailError: "" ,
                invitedFriends: data.result.invitations,
                isLoading: false
            })
        })
        .catch(data => this.setState({nameError: `Server: ${data.error}`, isLoading: false}))
    }
    render(){
        return(
            <div className="mainContent platformInvite">
                <div className="formHeader">
                    <h1>Invite your friend to the arcade!</h1>
                    <h3>You can then invite your friend to test your super secret&trade; games!</h3>
                </div>
                <form className="inviteForm" onSubmit={this.handleSubmit}>
                    
                    <div className="inputContainer">
                        <h3>Your friend's name:</h3>
                        <input type="text" name="friendName" value={this.state.friendName} onChange={this.handleChange}/>
                        <p className="error">{this.state.nameError}</p>
                    </div>
                    
                    <div className="inputContainer">
                        <h3>Your friend's email:</h3>
                        <input type="email" name="friendEmail" value={this.state.friendEmail} style={{textTransform: "lowercase"}}
                        pattern="^[a-zA-Z0-9\.]+@gmail\.com$" onChange={this.handleChange}/>
                        <p className="error">{this.state.emailError}</p>
                    </div>
                    <div className="alignRight">
                        <button className="inviteBtn submit" onClick={this.handleSubmit}>Invite!</button>
                    </div>
                </form>
                <InvitedList state={this.state} />                
            </div>
        )
    }
}

export default PlatformInvite